/** Comment ids and margin-card preview wording (#251). */

const SNIPPET_MAX = 48;

export function newCommentId(): string {
  return `c_${Math.random().toString(36).slice(2, 8)}`;
}

export function prefixSnippet(textBefore: string, max = SNIPPET_MAX): string {
  const cleaned = textBefore.replace(/\s+/g, " ").trimEnd();
  if (cleaned.trim().length === 0) return "";
  if (cleaned.length <= max) return cleaned.trimStart();
  let slice = cleaned.slice(-max);
  const space = slice.search(/\s/);
  if (space > 0 && space < Math.floor(max / 3)) {
    slice = slice.slice(space + 1);
  }
  return `…${slice.trimStart()}`;
}

export function suffixSnippet(textAfter: string, max = 32): string {
  const cleaned = textAfter.replace(/\s+/g, " ").trimStart();
  if (cleaned.trim().length === 0) return "";
  if (cleaned.length <= max) return cleaned.trimEnd();
  let slice = cleaned.slice(0, max);
  const space = slice.lastIndexOf(" ");
  if (space > Math.floor(max / 2)) slice = slice.slice(0, space);
  return `${slice.trimEnd()}…`;
}

export function rangePreviewText(text: string, max = SNIPPET_MAX): string {
  const cleaned = text.replace(/\s+/g, " ").trim();
  if (cleaned.length === 0) return "(empty)";
  if (cleaned.length <= max) return cleaned;
  return `${cleaned.slice(0, max - 1).trimEnd()}…`;
}
